import { useEffect } from "react";
import PropTypes from "prop-types";

export default function PaperformEmbed({ id }) {
  useEffect(() => {
    const existingScript = document.querySelector(
      'script[src="https://paperform.co/__embed.min.js"]',
    );

    if (!existingScript) {
      const script = document.createElement("script");
      script.src = "https://paperform.co/__embed.min.js";
      script.async = true;
      document.body.appendChild(script);
    } else if (window.Paperform?.loadEmbeds) {
      window.Paperform.loadEmbeds();
    }
  }, [id]);

  return <div data-paperform-id={id}></div>;
}

PaperformEmbed.propTypes = {
  id: PropTypes.string.isRequired,
};
